/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RestoreGcpCloudSqlDatabaseConfig {
  /**
  * The zone to restore the cloudsql instance to restore
  */
  'zone'?: string;
  /**
  * Optional labels to apply to the output instance
  */
  'labels'?: { [key: string]: string; };
  /**
  * The VPC network name for private networking
  */
  'networkName'?: string;
  /**
  * Host project ID for shared VPC
  */
  'networkHostProject'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "zone",
      "baseName": "zone",
      "type": "string",
      "format": ""
    },
    {
      "name": "labels",
      "baseName": "labels",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "networkName",
      "baseName": "networkName",
      "type": "string",
      "format": ""
    },
    {
      "name": "networkHostProject",
      "baseName": "networkHostProject",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreGcpCloudSqlDatabaseConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

